// src/utils/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // Use the HttpBackend to load translations from your server
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'en',
    // Supported languages
    supportedLngs: ['en', 'de', 'fr'],
    // Namespace for your translations
    ns: ['translation'],
    defaultNS: 'translation',
    
    // Debugging output in the console
    debug: true,

    // Backend configuration
    backend: {
      // Path where translations are stored in the public folder
      // {{lng}} will be replaced by the language code (en, de, fr)
      // {{ns}} will be replaced by the namespace (translation)
      loadPath: '/translations/{{lng}}.json',
    },

    interpolation: {
      escapeValue: false, // React already safes from XSS
    },

    react: {
      // Use Suspense for translations to load
      useSuspense: true,
    },
  });

export default i18n;